import { render, staticRenderFns } from "./MultiTextInput.vue?vue&type=template&id=70b680c2&"
import script from "./MultiTextInput.vue?vue&type=script&lang=js&"
export * from "./MultiTextInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports